import React from 'react';
import { TrashIcon } from 'lucide-react';
export const WasteManagementWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-2158">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2159">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2160">
          <TrashIcon className="h-5 w-5 text-amber-500 mr-2" data-id="element-2161" />
          Waste Management
        </h2>
      </div>
      <div className="p-6" data-id="element-2162">
        <div className="flex flex-col space-y-4" data-id="element-2163">
          <div className="flex justify-between items-center" data-id="element-2164">
            <span className="text-sm text-gray-600" data-id="element-2165">
              New Service Registrations
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2166">
              7
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2167">
            <span className="text-sm text-gray-600" data-id="element-2168">
              Missed Collections Today
            </span>
            <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2169">
              3
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2170">
            <span className="text-sm text-gray-600" data-id="element-2171">
              Bulk Pickups Scheduled
            </span>
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2172">
              11
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-2173">
            <p className="text-xs text-gray-700 font-medium" data-id="element-2174">
              Next Bulk Collection
            </p>
            <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2175">
              District 3 - June 15
            </p>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-2176">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2177">
          Manage Routes
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2178">
          View Service Requests
        </a>
      </div>
    </div>;
};